import { useState } from "react";
import { Card, CardContent, Button as ButtonUi, Box } from "@mui/material";
import { Button } from "../Button";
import { Header } from "../Header";
import {
  Container,
  Form,
  FormField,
  Input,
  Title,
  Load,
  LoadFile,
  StepsContainer,
  StepCard,
  StepNumber,
  StepTitle,
  StepDescription,
  SectionTitle,
  Content,
} from "./style";
import { Spinner } from "../../ui/Spinner";
import { Height, UploadFile } from "@mui/icons-material";
import { apiExtractor, apiOperation, headers } from "../../services/api";
import { Loading } from "../Loading";
import { useNavigate } from "react-router-dom";
import { getSessionUser } from "../../utils/users";
import { useEffect } from "react";
import { IUser } from "../Login/ILogin";
import React from "react";
import ErrorModal from "../ErrorModal";
import { getSessionToken } from "../../utils/users";

interface IArquivoGenerico {
  id: number;
  load?: boolean;
  name?: string | null;
  tipoDocumento: string;
}

let usuarioLogado: IUser | null = null;

export const BatchAnalysis = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [messagesLoading, setMessagesLoading] = useState<string>("");
  const [form, setForm] = useState<FormData>(new FormData());

  const [newUpload, setNewUpload] = useState<IArquivoGenerico>({
    id: 0,
    tipoDocumento: "",
  });

  useEffect(() => {
    usuarioLogado = getSessionUser();
    handleNewUpload();
  }, []);

  const handleNewUpload = () => {
    setNewUpload({ id: 0, name: null, load: false, tipoDocumento: "" });
  };

  const handleArquivoGenerico = async (target: any, id: number) => {
    if (!target.files) {
      return;
    }
    const file = target.files[0];

    console.log({ file, id });

    const { name } = file;
    newUpload.name = name;

    setLoadingModal(true);
    setMessagesLoading("Registrando analises...");

    const formData = new FormData();
    formData.append("file", file); // Adiciona o arquivo ao FormData

    setForm(formData);

    setLoadingModal(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function handleAnalise(): Promise<void> {
    setLoadingModal(true);
    try {
      const response = await apiOperation.post("analise/upload-excel", form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getSessionToken()}`,
        },
      });

      navigate("/historico-lote");
      setLoadingModal(false);
    } catch (error: any) {
      setLoadingModal(false);
      const msgError = `${error.code}
            Atualize a pagina e tente novamente!`;
      setErrorMsg(msgError);
      setOpen(true);
    }
  }

  const steps = [
    {
      number: 1,
      title: "Baixe a planilha modelo",
      description:
        "Faça o download do modelo em excel disponível na plataforma.",
    },
    {
      number: 2,
      title: "Preencha com os dados dos clientes",
      description:
        "Insira na planilha o(s) CPF(s) ou CNPJ(s) a serem analisados. A Razão Social é opcional, mas ajuda na identificação.",
    },
    {
      number: 3,
      title: "Envie a planilha editada",
      description:
        "Faça o upload do arquivo. Na análise em lote só são aceitos CPF e CNPJ, não use outros documentos.",
    },
    {
      number: 4,
      title: 'Clique em "Analisar"',
      description:
        'Depois do upload, clique no botão "Analisar" para iniciar o processo de verificação.',
    },
    {
      number: 5,
      title: "Aguarde o resultado",
      description: "Você receberá um e-mail quando a análise for concluída.",
    },
    {
      number: 6,
      title: "Acesse o relatório final",
      description:
        'Acesse a seção "Histórico Lote" para baixar o relatório completo em formato excel.',
    },
  ];

  return (
    <>
      <Header />
      <Loading
        mode="blurry"
        hidden={!loadingModal}
        messages={messagesLoading}
      />
      <Container>
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            flexDirection: "column",
            minWidth: 275,
            width: "fit-content",
            maxWidth: "100%",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Box>
              <Content>
                <Title>Análise em Lote</Title>
              </Content>
              <Card sx={{ padding: "20px" }}>
                <CardContent style={{ padding: "0" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Form style={{ width: "fit-content" }}>
                      <FormField key={newUpload.id}>
                        <div>
                          <label htmlFor={`contained-arquivo${newUpload.id}`}>
                            <ButtonUi
                              variant="outlined"
                              component="div"
                              endIcon={<UploadFile />}
                              sx={{
                                borderStyle: "dashed",
                                borderRadius: "15px",
                              }}
                            >
                              {!newUpload.name &&
                                "Selecione Seu Arquivo Excel"}
                              <Input
                                accept=".xlsx"
                                id={`contained-arquivo${newUpload.id}`}
                                multiple
                                hidden
                                type="file"
                                onChange={({ target }) => {
                                  handleArquivoGenerico(target, newUpload.id);
                                }}
                              />
                              {newUpload.load ? (
                                <LoadFile>
                                  <Spinner size={25} />
                                </LoadFile>
                              ) : (
                                <Box>{newUpload.name}</Box>
                              )}
                            </ButtonUi>
                          </label>
                        </div>
                      </FormField>
                    </Form>

                    <ButtonUi
                      variant="contained"
                      color="secondary"
                      onClick={handleAnalise}
                      sx={{
                        width: "10.4em",
                      }}
                    >
                      Analisar
                    </ButtonUi>
                  </Box>
                </CardContent>
              </Card>
            </Box>
            <Box>
              <Content>
                <Title>Como funciona a Análise Lote?</Title>
              </Content>
              <Card sx={{ padding: "20px" }}>
                <CardContent style={{ padding: "0" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <StepsContainer>
                      {steps.map((step) => (
                        <StepCard key={step.number}>
                          <StepNumber>{step.number}</StepNumber>
                          <StepTitle>{step.title}</StepTitle>
                          <StepDescription>{step.description}</StepDescription>
                        </StepCard>
                      ))}
                    </StepsContainer>

                    <a
                      href="https://extratordev.blob.core.windows.net/crediton/AnaliseLote_Modelo_Clientes.xlsx"
                      download
                    >
                      <ButtonUi
                        variant="contained"
                        color="secondary"
                        sx={{
                          width: "15.4em",
                          marginTop: "20px",
                        }}
                      >
                        MODELO DE PLANILHA
                      </ButtonUi>
                    </a>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box>
        </Box>
        <ErrorModal
          open={open}
          handleClose={handleClose}
          errorMsg={errorMsg}
          title="Pontos de atenção na análise!"
          onExit={() => {}}
          continuarAnalise={() => {}}
        />
      </Container>
    </>
  );
};
